import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPost from "../pages/blog/blog-post/page";
import BlogArticle2 from "../pages/blog/how-to-use/page";
import BlogArticle3 from "../pages/blog/sneaker-finds/page";
import BlogArticle4 from "../pages/blog/clothing-finds/page";
import BlogArticle5 from "../pages/blog/budget-finds/page";
import BlogArticle6 from "../pages/blog/vs-pandabuy/page";
import BlogArticle7 from "../pages/blog/how-sugargoo-works/page";
import BlogArticle8 from "../pages/blog/hoodie-collection/page";
import BlogArticle9 from "../pages/blog/yupoo-workflow/page";
import SafetyGuide from "../pages/safety/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Disclaimer from "../pages/disclaimer/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/safety-guide", element: <SafetyGuide /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/disclaimer", element: <Disclaimer /> },
  { path: "/blog/best-sugargoo-spreadsheet-2026-guide", element: <BlogPost /> },
  { path: "/blog/how-to-use-sugargoo-spreadsheet", element: <BlogArticle2 /> },
  { path: "/blog/top-50-sneaker-finds-sugargoo-spreadsheet", element: <BlogArticle3 /> },
  { path: "/blog/best-clothing-finds-sugargoo-spreadsheet", element: <BlogArticle4 /> },
  { path: "/blog/best-budget-finds-sugargoo-spreadsheet", element: <BlogArticle5 /> },
  { path: "/blog/sugargoo-spreadsheet-vs-pandabuy", element: <BlogArticle6 /> },
  { path: "/blog/how-sugargoo-works-2026", element: <BlogArticle7 /> },
  { path: "/blog/best-hoodie-spreadsheet-collection", element: <BlogArticle8 /> },
  { path: "/blog/yupoo-sugargoo-complete-workflow", element: <BlogArticle9 /> },
  { path: "*", element: <NotFound /> },
];

export default routes;